<template>
  <div v-if="attaches && attaches.length > 0" class="lv-meeting-item-attach-cards">
    <LvTextCard v-for="(attach_e, attach_k) in attaches" :key="attach_k" class="mt-8 mr-8 pt-0">
      <template v-slot:content>
        <ListCard isTable noPadding>
          <ListCardItem row isTable type="chip" :chip="attach_e.compressStatus" />
          <ListCardItem
            row
            isTable
            type="text"
            title="是否匯出附件名稱"
            :textContent="attach_e.isExportName ? '是' : '否'"
          />
          <ListCardItem
            row
            isTable
            type="text"
            title="附件名稱位置"
            :textContent="$_setTextExportNameLocation(attach_e.exportNameLocation)"
          />
          <ListCardItem
            row
            isTable
            type="text"
            title="匯出附件名稱"
            :textContent="attach_e.exportName"
          />
        </ListCard>
        <LvDownloadFileBtn
          :num="attach_k"
          :id="attach_e.id"
          :url="attach_e.url"
          :name="attach_e.name"
          :hasScope="attach_e.hasScope"
          :fileType="attach_e.fileType"
          :chipList="attach_e.chipList"
          :download="attach_e.hasScope"
          :showMoreBtn="attach_e.showMoreBtn"
          :showDownloadBtn="attach_e.showDownloadBtn"
          :isClickable="attach_e.isClickable"
          :isImageViewable="true"
          :versionNumber="attach_e.versionNumber"
          @go-to="$emit('go-to', $event)"
        />
      </template>
    </LvTextCard>
  </div>
  <LvText v-else h5>
    {{ $t('無') }}
  </LvText>
</template>

<script>
import H_meeting from '@/helpers/meeting';

export default {
  props: {
    attaches: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    $_setTextExportNameLocation(exportNameLocation) {
      return H_meeting.setExportNameLocationText(exportNameLocation);
    },
  },
};
</script>

<style lang="scss" scoped>
.lv-meeting-item-attach-cards {
  display: block;
  @media (min-width: 1400px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
}
</style>
